module.exports = __webpack_public_path__ + "images/vector/app/web/src/assets/loupe icon blue-b4a44e0c.svg";


//////////////////
// WEBPACK FOOTER
// ./app/web/src/assets/loupe icon blue.svg
// module id = ./app/web/src/assets/loupe icon blue.svg
// module chunks = 0